import { render } from "./Highlights.vue?vue&type=template&id=820972c0&scoped=true"
import script from "./Highlights.vue?vue&type=script&lang=js"
export * from "./Highlights.vue?vue&type=script&lang=js"

import "./Highlights.vue?vue&type=style&index=0&id=820972c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-820972c0"

export default script